import React from "react";
import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { config } from "components/footer/data";
import { horizontalContainerPadding } from "ui/container";
import { SubNav } from "./sub-nav";
import { NavItem } from "./nav-item";

export function NavColumns() {
  return (
    <SimpleGrid
      w="100%"
      columns={{ base: 2, sm: 3, md: 5 }}
      spacing="small"
      alignItems="start"
      justifyContent={{ base: "start", lg: "space-between" }}
      px={horizontalContainerPadding}
    >
      {config.map((nav) => (
        <Flex key={nav.title} direction="column" flex={1} gap="smaller">
          <Text textStyle="headline3" fontSize="brand.md">
            {nav.title}
          </Text>

          {nav.sub?.map((sub) => (
            <SubNav key={sub.title} title={sub.title}>
              {sub.nav?.map((item) => (
                <NavItem key={item.url ?? item.title} href={item.url} icon={item.icon} onClick={item.onClick}>
                  {item.title}
                </NavItem>
              ))}
            </SubNav>
          ))}
        </Flex>
      ))}
    </SimpleGrid>
  );
}
